import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { formatBs } from './utils'

ChartJS.register(ArcElement, Tooltip, Legend)

const COLORS = ['#118ab2', '#06d6a0', '#ffd166', '#ef476f', '#a78bfa', '#9ca3af']

export const DonutChart = ({ labels = [], data = [], title, valueFormatter = formatBs }) => {
    const total = data.reduce((a, b) => a + b, 0)

    const misoptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: { color: 'rgba(170,170,170)', boxWidth: 10, font: { size: 10 } },
            },
            tooltip: {
                callbacks: {
                    label: (ctx) => {
                        const value = ctx.raw || 0
                        const pct = total > 0 ? ((value / total) * 100).toFixed(1) : 0
                        return `${ctx.label}: ${valueFormatter(value)} (${pct}%)`
                    },
                },
            },
        },
    }

    return (
        <div className='w-full min-w-0'>
            <div className='text-sm dark:text-gray-300 text-gray-800 font-bold text-center mb-2'>{title}</div>
            {total === 0 ? (
                <div className='text-sm text-gray-500 dark:text-gray-400 italic text-center py-8'>
                    Sin datos para el rango seleccionado
                </div>
            ) : (
                <div className='w-full min-w-0 h-56 sm:h-64'>
                    <Doughnut
                        data={{
                            labels,
                            datasets: [{
                                data,
                                backgroundColor: labels.map((_, idx) => COLORS[idx % COLORS.length]),
                                borderWidth: 1,
                            }],
                        }}
                        options={misoptions}
                    />
                </div>
            )}
        </div>
    )
}
